import { api, unwrap } from "./api";
import { ApiError } from "./http";
import type { Role } from "./session";

export type GreenlightUser = {
  id: string;
  clickupUserId: string;
  name: string | null;
  email: string | null;
  avatarUrl: string | null;
  role: Role;
  status: string;
};

export type WorkspaceMember = {
  id: string;
  username: string | null;
  email: string | null;
  avatar: string | null;
};

export async function fetchUsers(): Promise<GreenlightUser[]> {
  const { users } = await unwrap(api.api.users.get());
  // `role`/`status` are text columns (server-typed `string`); the role select +
  // DB CHECK constrain them, so we narrow to the app's `Role` union here.
  return users as GreenlightUser[];
}

export async function fetchMembers(): Promise<WorkspaceMember[]> {
  const { members } = await unwrap(api.api.clickup.members.get());
  return members;
}

export async function createUser(input: {
  clickupUserId: string;
  name: string | null;
  email: string | null;
  avatarUrl: string | null;
  role: Role;
}): Promise<GreenlightUser> {
  try {
    const { user } = await unwrap(api.api.users.post(input));
    return user as GreenlightUser;
  } catch (e) {
    if (e instanceof ApiError && e.status === 409) {
      throw new Error("That user is already added.", { cause: e });
    }
    throw new Error("Please try again.", { cause: e });
  }
}
